var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('title-bar',{attrs:{"title-stack":['SECAPI', 'Acessos', 'Veículos', 'Cadastrar']}}),_c('section',{staticClass:"section is-main-section"},[_c('card-component',{attrs:{"title":"Cadastrar Acesso de Veículo","icon":"ballot"}},[_c('FormAcessoVeiculo')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }